module.exports = __webpack_public_path__ + "static/media/Baobab_Coin.15030590.svg";